export default "__VITE_ASSET__781c3ec3__"